import React, { useContext } from 'react';
import classes from './NewPostRoundButton.module.scss';
import { RoundButton } from '../../../components/actions/RoundButton';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { TopNavContext } from '../../../providers/TopNavProvider';
import { PostSource } from '../../../models/graphql';
import { OnboardingContext } from '../../Onboarding/states/OnboardingProvider';
import { useOpenPostEditor } from '../../../hooks/useOpenPostEditor';

export const NewPostRoundButtonView = (): JSX.Element => {
  const { openNewPost } = useOpenPostEditor();
  const { showOnboarding } = useContext(OnboardingContext);
  const { state } = useContext(TopNavContext);
  const { newPostCloseCallback } = state;

  const openPostEditor: VoidFunction = () => {
    openNewPost({
      source: PostSource.TN,
      onClose: newPostCloseCallback
    });
  };

  return showOnboarding ? (
    <></>
  ) : (
    <div className={classes.NewPostRoundButton}>
      <RoundButton
        action={openPostEditor}
        size={'large'}
        color={ButtonColorsEnum.secondary}
        icon={SquareButtonIconsEnum.edit}
      />
    </div>
  );
};
